// escapeLocalGuestRouting.js
// TEMPORARY Escape gameId detection helper.
//
// The root login flow now reuses Escape's real LandingPage directly, so this
// file no longer maps gameId -> route or changes BEGIN PLAY behavior.
//
// What remains is the minimum still required in this repo today:
// 1. detect whether the authenticated guest belongs to Escape so `/` can
//    render the correct landing experience without a second hardcoded UI, and
// 2. seed the local demo Escape login path with a known test gameId.
//
// See documentation/escape-to-inner-peace-guest-bootstrap-implementation.md.
// This helper is still a temporary architecture risk because the gameId list
// is hardcoded here instead of being supplied by a platform-owned launch
// contract.
export const ESCAPE_TO_INNER_PEACE_LOCAL_TEST_GAME_ID = 'f5a268e2-3ece-4f59-941e-9afd80c53962';

const ESCAPE_TO_INNER_PEACE_PLATFORM_GAME_IDS = new Set([
  ESCAPE_TO_INNER_PEACE_LOCAL_TEST_GAME_ID,
  '45f9ca72-0644-4732-a932-84aa2c8ee688',
]);

export function isEscapeToInnerPeaceGame(gameId) {
  return ESCAPE_TO_INNER_PEACE_PLATFORM_GAME_IDS.has(gameId);
}